import { AlertTriangle, CornerDownRight } from 'lucide-react';
import Dropdown from './Dropdown';
import StepIngredience from './StepIngredience';
import { fmtCena } from './receptUtils';

// Ingredience, které nepatří k žádnému kroku postupu (`sop_krok_id = null`).
// Vznikají hlavně smazáním kroku — položky zůstanou v kusovníku, ale v editoru
// je do teď nebylo kde vidět, přestože do kalkulace vstupují. Tenhle panel je
// zviditelní a umožní je přiřadit ke kroku nebo smazat.
export default function NeprirazenePanel({
    bom, steps, isDark, jednotky, itemCosts, materialTotal, costsPending,
    jednotkaZkratka, davkaMnozstvi, onNavigate, onUpdateBom, onDeleteBom, onReorderBom, onPresunout,
}) {
    const secondaryColor = isDark ? 'rgba(255,255,255,0.5)' : 'var(--text-secondary)';
    const mutedColor = isDark ? 'rgba(255,255,255,0.3)' : 'var(--text-muted)';
    const borderColor = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';

    const naklad = bom.reduce((sum, b) => sum + (Number(itemCosts?.get(String(b.id))?.cost) || 0), 0);

    return (
        <div className="rounded-xl" style={{
            background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.01)',
            border: `1px solid ${borderColor}`,
        }}>
            {/* Header */}
            <div className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: `1px solid ${borderColor}` }}>
                <div className="flex items-center justify-center rounded-full" style={{ width: 28, height: 28, flexShrink: 0, background: 'rgba(239,68,68,0.12)' }}>
                    <AlertTriangle size={14} style={{ color: '#EF4444' }} />
                </div>
                <div className="flex-1 min-w-0">
                    <div style={{ fontSize: 15, fontWeight: 500, color: 'var(--text-primary)' }}>Nepřiřazené ingredience</div>
                    <div className="text-[11px]" style={{ color: secondaryColor }}>
                        Nepatří k žádnému kroku — v receptu je nikdo neuvidí, ale do kalkulace se počítají
                        {naklad > 0 && <span style={{ color: '#EF4444', fontWeight: 600 }}> ({fmtCena(naklad)})</span>}.
                    </div>
                </div>
                {steps.length > 0 && (
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <CornerDownRight size={13} style={{ color: mutedColor }} />
                        <Dropdown
                            isDark={isDark}
                            height={30}
                            minWidth={190}
                            placeholder="Přesunout vše do kroku…"
                            value=""
                            options={steps.map((s, i) => ({ value: s.id, label: `${i + 1}. ${s.nazev || `Krok ${i + 1}`}` }))}
                            onChange={(stepId) => { if (stepId) onPresunout(stepId); }}
                        />
                    </div>
                )}
            </div>

            {/* Seznam — stejné řádky i sloupec nákladů jako u kroku, jen bez hledání */}
            <div className="p-4">
                <StepIngredience
                    step={{ id: null }}
                    stepBom={bom}
                    isDark={isDark}
                    jednotky={jednotky}
                    itemCosts={itemCosts}
                    materialTotal={materialTotal}
                    costsPending={costsPending}
                    jednotkaZkratka={jednotkaZkratka}
                    davkaMnozstvi={davkaMnozstvi}
                    souhrnLabel="Nepřiřazený materiál"
                    onNavigate={onNavigate}
                    skrytHledani
                    onUpdateBom={onUpdateBom}
                    onDeleteBom={onDeleteBom}
                    onReorderBom={onReorderBom}
                />
            </div>
        </div>
    );
}
